import React, { useState } from "react";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Send, ArrowUp } from "lucide-react";
import "./styles/Footer.css";

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubmit = () => {
    if (email) {
      alert(`Thank you for subscribing with: ${email}`);
      setEmail("");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer className="footer">
        {/* Animated wave decoration */}
        <div className="wave-decoration">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="wave-path"></path>
            <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="wave-path"></path>
            <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="wave-path"></path>
          </svg>
        </div>

        <div className="footer-content">
          <div className="footer-top">
            {/* About Column */}
            <div className="footer-col about">
              <div className="logo-container">
                <img src="/OEG Logo.png" alt="Ozzi Education Group" className="footer-logo" />
                <span className="logo-text">Ozzi Education Group</span>
              </div>
              <p className="footer-description">
                Ozzi Education Group provides world-class education, empowering students with knowledge, skills, and opportunities to succeed globally.
              </p>
              <div className="social-icons">
                <a href="https://www.facebook.com/people/OZZI-Education-Group/61580854895659" className="social-link" aria-label="Facebook" target="blank">
                  <Facebook size={20} />
                </a>
                <a href="https://www.instagram.com/ozzieducationgroup" className="social-link" aria-label="Instagram" target="blank">
                  <Instagram size={20} />
                </a>
                {/* <a href="#" className="social-link" aria-label="LinkedIn">
                  <Linkedin size={20} />
                </a> */}
              </div>
            </div>

            {/* Quick Links Column */}
            <div className="footer-col quick-links">
              <h4>Quick Links</h4>
              <div className="links-grid">
                <a href="#about" className="footer-link">About Us</a>
                <a href="#courses" className="footer-link">Our Courses</a>
                <a href="#admissions" className="footer-link">Study in Australia</a>
              </div>
              <button onClick={() => window.location.href = '#contact'} className="contact-us-btn">
                <Mail size={18} />
                <span>Contact Us</span>
              </button>
            </div>

            {/* Contact & Map */}
            <div className="footer-col contact">
              <h4>Contact Us</h4>
              <div className="contact-items">
                <a href="tel:+61410338620" className="contact-item">
                  <Phone size={18} />
                  <span>+61 410 338 620</span>
                </a>
                <a href="mailto:info@ozzieducationgroup.vic.edu.au" className="contact-item">
                  <Mail size={18} />
                  <span>info@ozzieducationgroup.vic.edu.au</span>
                </a>
                <a href="https://maps.google.com/?q=341+Queen+Street+Melbourne" target="_blank" rel="noopener noreferrer" className="contact-item">
                  <MapPin size={18} />
                  <span>Level 3, 341 Queen Street, Melbourne VIC 3000</span>
                </a>
              </div>
              <div className="map-container">
                <iframe
                  title="OEG Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.104377472254!2d144.9609363157919!3d-37.815482979751826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642b320cc7d71%3A0xdca35f10f91c1b1e!2s341%20Queen%20St%2C%20Melbourne%20VIC%203000%2C%20Australia!5e0!3m2!1sen!2sus!4v1699999999999!5m2!1sen!2sus"
                  width="100%"
                  height="200"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>© 2025 Ozzi Education Group. All rights reserved.</p>
          </div>
        </div>

        {/* Scroll to top button */}
        <button 
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <ArrowUp size={20} />
        </button>
      </footer>
    </>
  );
}